import i18nConfig from 'i18n';
import { useMemo } from 'react';

type LanguagePaths = {
  languages: string[];
  paths: {
    [key: string]: string;
  };
};

function useLanguagePaths(): LanguagePaths {
  return useMemo(
    () => ({
      languages: [...(i18nConfig.locales as string[])],
      paths: i18nConfig.locales.reduce(
        (acc, locale) => ({
          ...acc,
          [locale]: locale === 'pl' ? '' : `/${locale}`,
        }),
        {},
      ),
    }),
    [],
  );
}

export default useLanguagePaths;
